// extracted by mini-css-extract-plugin
module.exports = {"main":"order-details_main__2a1_D","error_text":"order-details_error_text__1zWgO","shadow":"order-details_shadow__jhh8a"};